import { render } from "./schoolNames.vue?vue&type=template&id=41ac3b4c&scoped=true"
import script from "./schoolNames.vue?vue&type=script&lang=js"
export * from "./schoolNames.vue?vue&type=script&lang=js"

import "./schoolNames.vue?vue&type=style&index=0&id=41ac3b4c&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ac3b4c"]])

export default __exports__